import { apiRequest } from '../client';

export type DrawRecurrenceType = 'ONE_TIME' | 'DAILY' | 'SUPER_SUNDAY';
export type DrawMode = 'REGULAR' | 'SINGLE_TNDOLA';

export type AdminDraw = {
  id: string; title: string; drawDate: string; drawTime: string;
  firstSafa: string; secondSafa: string; firstAkra: string; secondAkra: string;
  firstTndola: string; secondTndola: string; firstPangora: string; secondPangora: string;
  isActive: boolean; recurrenceType: DrawRecurrenceType; drawMode: DrawMode;
  resultUpdated?: boolean; seriesKey?: string | null;
};

export type DrawFormInput = Omit<AdminDraw, 'id' | 'resultUpdated' | 'seriesKey'>;
export type DrawListResponse = { ok: true; draws: AdminDraw[]; pagination?: { page: number; pageSize: number; total: number; totalPages: number } };

export const adminDrawsApi = {
  list: (query?: { page?: number; pageSize?: number; search?: string }) => {
    const params = new URLSearchParams();
    if (query?.page) params.set('page', String(query.page));
    if (query?.pageSize) params.set('pageSize', String(query.pageSize));
    if (query?.search?.trim()) params.set('search', query.search.trim());
    const suffix = params.toString();
    return apiRequest<DrawListResponse>(`/api/draws${suffix ? `?${suffix}` : ''}`);
  },
  get: (id: string) => apiRequest<{ ok: true; draw: AdminDraw }>(`/api/draws/${encodeURIComponent(id)}`),
  create: (input: DrawFormInput) => apiRequest<{ ok: true; id: string }>('/api/draws', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: string, input: DrawFormInput) => apiRequest<{ ok: true }>(`/api/draws/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify(input) }),
  toggle: (id: string) => apiRequest<{ ok: true; isActive: boolean; seriesResumed?: boolean }>(`/api/draws/${encodeURIComponent(id)}/toggle`, { method: 'POST' }),
};
